// extracted by mini-css-extract-plugin
module.exports = {"paginationSection":"Pagination_paginationSection__KCPx8","pagination":"Pagination_pagination__c3_NG","true":"Pagination_true__KqOEL"};